import './styles/globals.css';

import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { drawLedgerTiles } from '@/lib/insight-business-layout';

import { initClarity } from './clarity';
import { initSentry, reactErrorHandler } from './instrument';
import { router } from './router';

const root = document.getElementById('root');
if (root === null) throw new Error('index.html has no #root.');

initSentry(router);
initClarity();
// The web pins and draws a money figure on the Dashboard (step 12.5 of docs/plans/ledger.md; it says `ledger_cards`).
drawLedgerTiles(true);

createRoot(root, {
  onUncaughtError: reactErrorHandler(),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
